(function () {
    'use strict';
    angular.uniqueId = function () {
        return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    angular.compICase = function (s1, s2) {
        return s1.toLowerCase() === s2.toLowerCase();
    };


    /** Refresh view on window focus **/
    angular.element(window).bind('focus', function () {
        setTimeout(function () {
            $(window).resize();
        }, 5);
    });
})();